export const hasRole = (user, requiredRole) => {
  if (requiredRole === 'ADMIN') {
    return user.authorizationAttributes.role === 'ADMIN';
  }
  if (requiredRole === 'EMPLOYER') {
    return (
      user.authorizationAttributes.role === 'ADMIN' ||
      user.authorizationAttributes.role === 'EMPLOYER'
    );
  }
  return true;
};

/**
 * Determine if a user is a customer
 * @todo consolidate with same function in auth.js
 * @param {*} user
 */
// export const isEmployer = (user) => user.role === 'EMPLOYER';

/**
 * check if user has one of the required roles
 * @param {*} user
 * @param {*} authorizedRoles
 * @param {*} companyContextSlug
 * @returns
 */
export const authorize = (user, authorizedRoles, routeSlug) => {
  // if user is a customer he can only access resources of his own company
  // if (
  //   (user.role === 'EMPLOYER') &&
  //   user.company.slug != routeSlug
  // ) {
  //   return false;
  // }

  // check if user has one of the required roles
  let authorized = false;
  authorizedRoles.map((role) => {
    if (role === user.role) {
      authorized = true;
    }
  });

  return authorized;
};

/**
 * check if the users email matches one of the authorizedUsers
 * @param {*} user
 * @param {*} authorizedUsers
 * @returns
 */
export const authorizeByUser = (user, authorizedUsers) => {
  let authorized = false;
  authorizedUsers.map((email) => {
    if (email === user.email) {
      authorized = true;
    }
  });

  return authorized;
};

/**
 * Checks if a user has permission to access a resource based on their policies
 *
 * @param {Object} user - The user requesting access
 * @param {String} resourceType - The type of resource being accessed
 * @param {Array} requiredActionPermissions - The permissions required to access the resource
 * @param {Object} resource - Optional resource object to check ownership
 * @returns {Boolean} - Whether the user has permission to access the resource
 */
export const hasResourcePermission = (user, resourceType, requiredActionPermissions, resource) => {
  // Get userPolicies from the Vuex store
  const userPolicies = require('@/store').default.getters['policies/getUserPolicies'];

  // console.log(
  //   'hasResourcePermission',
  //   user.email,
  //   user.authorizationAttributes.role,
  //   user.authorizationAttributes.department,
  //   resourceType,
  //   requiredActionPermissions
  //   // userPolicies
  // );

  if (!user) return false;

  // Admin sees everything
  if (user && user.authorizationAttributes.role === 'ADMIN') return true;

  // If no resource type or permissions specified, do not allow access
  if (!resourceType || !requiredActionPermissions || requiredActionPermissions.length === 0) {
    return false;
  }

  // If no policies exist yet, deny access
  if (!userPolicies || userPolicies.length === 0) {
    return false;
  }

  // Check if there are OWNER policies for this resource type
  const ownerPolicies = userPolicies.filter(
    (policy) =>
      policy.userConditions &&
      policy.userConditions.role === 'OWNER' &&
      policy.resourceConditions &&
      policy.resourceConditions.resourceType === resourceType
  );

  console.log(`Found ${ownerPolicies.length} OWNER policies for resource type ${resourceType}`);
  if (ownerPolicies.length > 0) {
    console.log('OWNER policies:', JSON.stringify(ownerPolicies, null, 2));
  }

  // If there are OWNER policies and the user is the owner of the resource, grant permission
  if (ownerPolicies.length > 0 && resource && resource.ownerId === user.id) {
    console.log(`User ${user.email} is the owner of the resource with id: ${resource.id}`);

    const hasOwnerPermission = ownerPolicies.some((policy) =>
      requiredActionPermissions.some((permission) => policy.actionConditions.includes(permission))
    );

    console.log(`Has OWNER permission check (resource): ${hasOwnerPermission}`);

    if (hasOwnerPermission) {
      console.log(`Granted access to ${user.email} as the OWNER of resource ${resource.id}`);
      return true;
    }
  }

  // Special case: if there's an OWNER policy without requiring the resource object,
  // we grant permission to any user for that resource type
  const ownerPoliciesWithoutResourceCheck = ownerPolicies.filter(
    (policy) => !policy.resourceConditions.userHasToBeAssignedToResource
  );

  console.log(
    `Found ${ownerPoliciesWithoutResourceCheck.length} OWNER policies without resource check`
  );
  if (ownerPoliciesWithoutResourceCheck.length > 0) {
    console.log(
      'OWNER policies without resource check:',
      JSON.stringify(ownerPoliciesWithoutResourceCheck, null, 2)
    );

    const hasPermission = ownerPoliciesWithoutResourceCheck.some((policy) =>
      requiredActionPermissions.some((permission) => policy.actionConditions.includes(permission))
    );

    console.log(`Has OWNER permission check (general): ${hasPermission}`);
    console.log(`Required permissions: ${JSON.stringify(requiredActionPermissions)}`);

    if (hasPermission) {
      console.log(`Granted access to ${user.email} via generic OWNER policy for ${resourceType}`);
      return true;
    }
  }

  // Find policies that match this user's role and the specified resource
  const matchingPolicies = userPolicies.filter((policy) => {
    // Check if policy is active
    // if (!policy.isActive) return false;

    // Skip OWNER policies as they're handled above
    if (policy.userConditions && policy.userConditions.role === 'OWNER') {
      return false;
    }

    // Check if policy applies to this user's role
    if (
      policy.userConditions &&
      policy.userConditions.role &&
      policy.userConditions.role !== 'ANYONE' &&
      policy.userConditions.role !== user.authorizationAttributes.role
    ) {
      return false;
    }

    // Check if policy applies to this user's department
    if (
      policy.userConditions &&
      policy.userConditions.department &&
      policy.userConditions.department !== 'ANYONE' &&
      policy.userConditions.department !== user.authorizationAttributes.department
    ) {
      return false;
    }

    // Check if policy applies to the requested resource type
    if (
      policy.resourceConditions &&
      policy.resourceConditions.resourceType &&
      policy.resourceConditions.resourceType !== resourceType
    ) {
      return false;
    }

    return true;
  });

  console.log(
    `--- ${matchingPolicies.length} matching policies of ${userPolicies.length} found ---`
  );
  for (const policy of matchingPolicies) {
    console.log(`actionConditions: ${policy.actionConditions}`);
    console.log(
      `resourceConditions - resourceType: ${policy.resourceConditions.resourceType}, userHasToBeAssignedToResource: ${policy.resourceConditions.userHasToBeAssignedToResource}`
    );
    console.log(
      `userConditions - role: ${policy.userConditions.role}, department: ${policy.userConditions.department}`
    );
  }

  const authorized = matchingPolicies.some((policy) => {
    if (!policy.actionConditions) return false;

    return requiredActionPermissions.some((permission) =>
      policy.actionConditions.includes(permission)
    );
  });
  console.log(
    `hasResourcePermission() - ${user.email} is authorized to: ${requiredActionPermissions} ${resourceType}: ${authorized} `
  );

  return authorized;
};

/**
 * Check if a user can write to a specific field based on guest permissions
 * @param {String} field - The field name to check
 * @param {Object} guestWritableFields - Object containing writable fields configuration
 * @returns {Boolean} - Whether the user can write to the field
 */
export const canWriteField = (field, guestWritableFields) => {
  const isGuest = require('@/store').default.getters['auth/isGuest'];
  // console.log('canWriteField', isGuest, field, guestWritableFields);
  return (isGuest && guestWritableFields[field]) || !isGuest;
};

/**
 * Check if a section should be visible to a guest user
 * @param {String} section - The section name to check
 * @param {Object} guestVisibleSections - Object containing visible sections configuration
 * @returns {Boolean} - Whether the section should be visible
 */
export const showToGuest = (section, guestVisibleSections) => {
  const isGuest = require('@/store').default.getters['auth/isGuest'];
  // console.log('showToGuest', isGuest, section, guestVisibleSections);
  return (isGuest && guestVisibleSections[section]) || !isGuest;
};
